/**
 * 닉네임의 길이 상한.
 *
 * 세는 단위는 grapheme cluster다. 코드 유닛으로 세면 한글 한 글자가 셋으로도 잡히고 이모지
 * 하나가 여럿으로 잡혀 화면이 알리는 수와 사람이 세는 수가 갈린다. 서버도 같은 단위로 센다.
 */
export const NICKNAME_MAX_LENGTH = 20

const segmenter = new Intl.Segmenter(undefined, { granularity: 'grapheme' })

/** 사람이 세는 대로 센다. */
export function countGraphemes(value: string): number {
  return [...segmenter.segment(value)].length
}

/**
 * 저장 전에 다듬는다.
 *
 * 앞뒤 공백을 없애고 줄바꿈을 공백 하나로 바꾼다. 한 줄로 서는 값이라 줄바꿈이 들어오면
 * 행에서 잘려 보이지 않는 글자가 생긴다.
 */
export function normalizeNickname(value: string): string {
  return value.normalize('NFC').replace(/\s+/g, ' ').trim()
}

export interface Nickname {
  nickname: string
}
